import { Button } from "@/components/ui/baseUi/button"
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/baseUi/dialog"
import { Switch } from "@/components/ui/baseUi/switch"
import { Text } from "@/components/ui/baseUi/text"
import { word } from "@/modules/core/utils/i18n"
import { useServicesContext } from "@modules/core/services/services.context"
import { BugIcon, CheckIcon } from "lucide-react"
import { useObservable } from "micro-observables"

type DebugDialogProps = {
  visible: boolean
  setVisible: (b: boolean) => void
}

export function DebugDialog({ visible, setVisible }: DebugDialogProps) {
  const { featureToggleService } = useServicesContext()
  const featureToggles = useObservable(featureToggleService.featureToggles)

  return (
    <Dialog open={visible} onOpenChange={() => setVisible(false)}>
      <DialogContent className="w-2xl">
        <DialogHeader>
          <DialogTitle>
            <div className="">
              <Text fontStyle="TL">Activer les features</Text>
            </div>
          </DialogTitle>
        </DialogHeader>

        {featureToggles.map((feature) => (
          <div key={feature.key} className="flex flex-row items-center justify-between">
            <label>{feature.key}</label>
            <Switch
              checked={feature.isEnabled}
              onCheckedChange={() => {
                featureToggleService.updateFeatureToggle({ key: feature.key, isEnabled: !feature.isEnabled })
              }}
            />
          </div>
        ))}

        <Button
          variant="secondary"
          size="lg"
          className="w-fit"
          onClick={() => {
            throw new Error("Sentry Test Error")
          }}
        >
          <BugIcon className="size-4" />
          Simulate crash
        </Button>

        <DialogFooter>
          <Button variant="primary" size="lg" onClick={() => setVisible(false)}>
            {word("global.check")}
            <CheckIcon className="size-4" />
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
